/**
 * đơn vị tính - kèm text "ĐVT:"
 * NXHinh 15.11.2024
 */
export default {
    One: 0,
    Thousand: 1,
    Million: 2,
    Billion: 3,
  };